import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[sideBarHost]',
  standalone: true
})
export class SideBarDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}